import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanActivateGuard, LayoutAuthComponent, LayoutLockscreenComponent} from './ngx-admin-lte';



// Components
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { ClientComponent } from './pages/client/client.component';
import { ClientEditComponent } from './pages/client/edit/edit';
import { CategorieComponent } from './pages/categorie/categorie.component';
import { CategorieEditComponent } from './pages/categorie/edit/edit';
import { UserComponent } from './pages/user/user.component';
import { UserEditComponent } from './pages/user/edit/edit';
import { ProduitComponent } from './pages/produit/produit.component';
import { ProduitEditComponent } from './pages/produit/edit/edit';
import { PrestationComponent } from './pages/prestation/prestation.component';
import { PrestationEditComponent } from './pages/prestation/edit/edit';
import { FactureComponent } from './pages/facture/facture.component';
import { FactureEditComponent } from './pages/facture/edit/edit';
import { AchatComponent } from './pages/achat/achat.component';
import { AchatEditComponent } from './pages/achat/edit/edit';

const routes: Routes = [

  // logged routes
  {
    canActivate: [CanActivateGuard],
    children: [
      {
        component: HomeComponent,
        path: ''
      },
      {
        component: HomeComponent,
        path: 'home'
      },
      { path: 'facture/client/:id', component: HomeComponent},
      { path: 'client/:id', component: ClientEditComponent },
      { path: 'client', component: ClientComponent },
      { path: 'categorie/:id', component: CategorieEditComponent },
      { path: 'categorie', component: CategorieComponent },
      { path: 'user/:id', component: UserEditComponent },
      { path: 'user', component: UserComponent },
      { path: 'produit/:id', component: ProduitEditComponent },
      { path: 'produit', component: ProduitComponent },
      { path: 'achat/:id', component: AchatEditComponent },
      { path: 'achat', component: AchatComponent },
      { path: 'prestation/:id', component: PrestationEditComponent },
      { path: 'prestation', component: PrestationComponent },
      { path: 'facture/:id', component: FactureEditComponent },
      { path: 'facture', component: FactureComponent }
    ],
    component: LayoutAuthComponent,
    data: [{
      'skin': 'skin-black',
      'boxed_style': false,
      'display_tasks': false,
      'display_control': false,
      'display_user': false,
      'display_messages': false,
      'display_notifications': false,
      'display_menu_user': false,
      'display_menu_search': false,
      'display_logout': true,
      'display_control_sidebar': false
    }],
    path: '',
  },
  // not logged routes
  {
    children: [
      {
        component: LoginComponent,
        path: ''
      }
    ],
    component: LayoutLockscreenComponent,
    path: 'login',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
